<template>
	<div style="height: 83vh; overflow-y: hidden">
		<div class="header">
			<div class="header_title-container title">
				<h1>
					{{ $t("fill") }}:
					<span style="font-weight: 900; margin-left: 5px">{{ docTitle }}</span>
				</h1>
			</div>
			<div class="header_actions">
				<div class="header_actions-container">
					<!-- Save -->
					<el-dropdown v-if="isDraft && mySubscription" @command="handleSaveCommand">
						<el-button icon="el-icon-plus" type="success" plain>
							{{ $t("save") }}
						</el-button>
						<el-dropdown-menu>
							<el-dropdown-item icon="el-icon-document" command="saveCustomFieldValues">
								{{ $t("save-draft") }}
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-check" command="savePermanently">
								{{ $t("save-permanently") }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<!-- Export -->
					<el-button icon="el-icon-download" type="success" plain @click="exportDocx" :loading="exporting">
						{{ $t("export") | capitalize }}
					</el-button>

					<!-- <el-dropdown @command="handleExportCommand">
						<el-button icon="el-icon-download" type="success" plain>
							{{ $t("export") | capitalize }}
						</el-button>
						<el-dropdown-menu>
							<el-dropdown-item icon="el-icon-document" command="exportPdf">
								{{ $t("save") }} PDF
							</el-dropdown-item>
							<el-dropdown-item icon="el-icon-document" command="exportDocx">
								{{ $t("save") }} Doc
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</div>
			</div>
		</div>

		<!-- Alert saved permanently -->
		<template v-if="!isDraft">
			<el-alert :title="$t('warning-permanently-saved-document')" type="warning" :closable="false" show-icon>
			</el-alert>
			<br />
		</template>
		<template v-if="!mySubscription">
			<el-alert :title="$t('warning-subscription-expired-doc')" type="warning" :closable="false" show-icon>
			</el-alert>
			<br />
		</template>

		<el-button @click="collapseqs = !collapseqs" circle size="mini" style="margin-bottom: 10px">
			<md-icon v-if="!collapseqs">keyboard_double_arrow_right</md-icon>
			<md-icon v-if="collapseqs">keyboard_double_arrow_left</md-icon>
		</el-button>

		<div v-if="isLoaded" style="display: flex; width: 100%">
			<!-- Custom fields -->

			<div
				v-show="collapseqs"
				v-if="isDraft && mySubscription"
				style="display: flex; flex-direction: column; overflow-y: auto; height: 70vh; padding-bottom: 150px"
			>
				<div
					v-if="questions.filter(x => isItAnObjectQuestionMark(x.question.value)).length > 0"
					style="margin-bottom: 5vh"
				>
					<div
						v-for="(s, index) in questions.filter(x => isItAnObjectQuestionMark(x.question.value))"
						:key="index"
						:id="'qst_' + s.id + '-' + s.id"
						hidden
					>
						<h4 v-if="index === 0">{{ $t("questions") | capitalize }}</h4>
						<div style="border: 1pt solid #ccc; padding: 25px">
							<div
								v-if="isItAnObjectQuestionMark(s.question.value)"
								class=""
								style="font-weight: 900; font-size: 18px; padding: 10px; width: 100%"
							>
								{{ s.question.value.name ? s.question.value.name : s.question.value }}
							</div>
							<div class="isaq" v-if="isItAnObjectQuestionMark(s.question.value)">
								<div
									class=""
									:key="s.id + 2"
									v-if="s.question.value !== undefined"
									style="display: flex; width: 100%; flex-wrap: wrap"
								>
									<div class="" style="width: 100%">
										<div class="" v-for="(a, i) in s.question.map" :key="i + '' + s.id">
											<el-radio
												@change="
													setValue({ element: s, val: s.value })
													calculateProgress()
													hideVariables()
													hideQuestions2(index)
												"
												v-model="s.value"
												:label="a.ref"
												>{{ a.value }}
											</el-radio>
										</div>
									</div>
								</div>
							</div>
							<!-- choice -->
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'choice'"
							></div>
							<!--number-->
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'number'"
							>
								<el-input-number
									v-if="s.question.value.level > 0 && s.question.value.level !== undefined"
									@change="
										setValue({ element: s, val: s.value })
										calculateProgress()
									"
									v-model="s.value"
								></el-input-number>
							</div>
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'image'"
							></div>
							<div
								class="isaq"
								v-else-if="typeof s.question.value === 'object' && s.question.value.type === 'text'"
							></div>
							<div class="isaq" v-else>ERR</div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-bottom: 5vh" v-if="variabili.length !== 0">
					<div style="border: 1pt solid #ccc; padding: 25px">
						<el-row type="flex" align="middle">
							<span>
								{{ $t("go-to-bio-informations") }}
							</span>
							<md-button class="md-icon-button">
								<router-link :to="bioInfoRoute" target="_blank">
									<md-icon>open_in_new</md-icon>
								</router-link>
							</md-button>
						</el-row>
					</div>

					<div
						v-for="(variabile, index) in variabili"
						:key="index"
						:id="`com_${variabile.node.id}-${variabile.rid}`"
						:locked_var="'false'"
						:locked_qst="'false'"
						hidden
						:style="{ border: variabile.isqst ? '3px solid green' : 'none' }"
					>
						<el-row
							v-if="index === 0 || variabili[index - 1].node.level !== variabile.node.level"
							type="flex"
							align="middle"
						>
							<h4>{{ $t("data") | capitalize }} {{ $t(levelTexts[variabile.node.level].name) }}</h4>
							<el-tooltip :content="$t(levelTexts[variabile.node.level].help)" placement="top">
								<md-icon>help</md-icon>
							</el-tooltip>
						</el-row>

						<variable-input
							ref="variable-input"
							:variable="variabile"
							@setField="setField"
							@focusField="focusField"
							@unfocusField="unfocusField"
							@handleImage="handleImage"
						/>
					</div>
				</div>
			</div>
			<!-- Preview -->
			<div
				style="flex: 1; background-color: #fff; height: 70vh; overflow-y: auto; display: flex"
				id="save-permanently-html-preview"
			>
				<flat-renderer
					:key="refreshable"
					v-if="isDraft && doc && loadNext"
					:dati="doc"
					:id="'rend' + random_id"
					:toggleBorders="false"
					:logged="true"
					:style="{ width: sidebar ? '100%' : 'calc(100% - 300px)' }"
					@end="hideVariables"
					@end2="
						val => {
							hideQuestions(val)
						}
					"
				/>
				<div
					style="width: 100%"
					v-else-if="document && document.html"
					v-html="document.html"
					v-once
					:id="'rend' + random_id"
				/>
				<div v-if="mySubscription">
					<fill-sidebar from="fill-layout" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { filters } from "@/utils/utils"
import FlatRenderer from "@/modules/flowcharts/flat-renderer"
import VariableInput from "./components/variable-input"
import FillSidebar from "@/modules/documents/fill-sidebar"
import _ from "lodash"
import { uuid } from "@/modules/builder/utils/utils"
export default {
	name: "fill-layout",
	mixins: [filters],
	props: {
		doc_id: {
			required: false
		},
		doc_ids: {
			required: false
		},
		exportHTML: {
			required: false,
			type: Boolean
		}
	},
	components: {
		FillSidebar,
		FlatRenderer,
		VariableInput
	},
	data() {
		return {
			collapseqs: true,
			isLoaded: false,
			selected_doc_id: undefined,
			document: null,
			doc: null,
			last_visible_question: undefined,
			docTitle: null,
			random_id: this.uuid(),
			local_questions: [],
			variables: [],
			loadNext: false,
			levelTexts: {
				"-1": { name: "required-tag", help: "required-data-help" },
				0: { name: "global-tag", help: "global-data-help" },
				1: { name: "project-tag", help: "project-data-help" },
				2: { name: "procedure-tag", help: "procedure-data-help" },
				3: { name: "document-tag", help: "document-data-help" }
			},
			// question_tree: {},
			question_path: [],
			question_path_variables: [],

			try_msec: 20000, //se si modifica questo, modificare anche dentro myprojects
			try_number: 0,
			max_try_number: 4,

			exporting: false
		}
	},
	computed: {
		...mapGetters({
			sidebar: "documents/sidebar",
			mySubscription: "organization/active_subscription",
			customFields: "prose/variables",
			user: "user/user",
			questions: "compilation/questions",
			refreshable: "compilation/refreshable",
			normalizedVariables: "compilation/variables",
			progressPercentage: "compilation/progressPercentage",
			progressColor: "compilation/progressColor",
			isSuperAdmin: "user/isSuperAdmin"
		}),
		isDraft() {
			return this.document && this.document.status === "draft"
		},
		bioInfoRoute() {
			return this.isSuperAdmin
				? { name: "users.schools.school_id", params: { school_id: this.$route.params.school_id } }
				: { name: "settings.organizations" }
		},
		variabili() {
			return this.normalizedVariables
				.filter(({ node: { level } }) => level > 0)
				.sort(
					({ node: nodeA }, { node: nodeB }) =>
						nodeA.level - nodeB.level || new Date(nodeA.created_at) - new Date(nodeB.created_at)
				)
		},
		variabiliNonSortate() {
			return this.normalizedVariables.filter(({ node: { level } }) => level > 0)
		}
	},
	async mounted() {
		this.try_number = 0
		if (!this.exportHTML) this.openload()

		await this.start()

		if (this.exportHTML) {
			setTimeout(async () => {
				await this.eora()
			}, this.try_msec) //dopo try_msec millisec chiamo eora
			//se si modifica questo tempo modificare anche il tempo dentro MyProjects -> StartDownloadAll
		} else {
			this.closeload()
		}

		this.$store.dispatch("modules/doSettings")
	},
	beforeDestroy() {
		this.clear()
	},
	updated() {},
	methods: {
		uuid,
		async eora() {
			this.isLoaded = true

			//controllo che il documento sia stato renderizzato, altrimenti ricontrollo fra this.msec msec
			//per un massimo di this.max_try_number

			let a = document.getElementById("rend" + this.random_id)
			if (!a && this.try_number < this.max_try_number) {
				this.try_number++
				setTimeout(async () => {
					await this.eora()
				}, this.msec)
				return
			}

			this.$emit("loaded", {
				content: this.exportActual(),
				title: this.docTitle,
				unique: this.document.unique_flowchart_id
			})
		},

		async start() {
			this.selected_doc_id = this.doc_id || this.$route.params.documentId
			await this.getData()

			const owners = {}
			owners[this.$route.params.school_id || this.user.organization.id] = [-1, 0]
			owners[this.document.project.project_id || this.document.project_id] = [1]
			owners[this.document.project_id] = [2]
			owners[this.document.id] = [3]

			this.setOwners(owners)

			this.isLoaded = true
		},

		...mapActions({
			addQuestions: "compilation/addQuestions",
			addVariables: "compilation/addVariables",
			connectQuestionVar: "compilation/connectQuestionVar",
			updateValue: "compilation/updateValue",
			setValue: "compilation/setValue"
		}),
		...mapMutations({
			setPercentage: "compilation/SET_PERCENTAGE",
			setOwners: "compilation/SET_OWNERS",
			clear: "compilation/CLEAR_STATE",
			openload: "modules/OPEN_LOADING",
			closeload: "modules/CLOSE_LOADING"
		}),

		checkSaved(data) {
			if (data) {
				data.forEach((componente, index, theArray) => {
					if (componente.ref_id) {
						axios
							.get(process.env.VUE_APP_API_URL + "/api/blocks/getSavedBlock/" + componente.ref_id, {
								headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
							})
							.then(res => {
								res.data.blocks.json.ref_id = res.data.blocks.ref_id
								res.data.blocks.json.deleted = null
								res.data.blocks.json.name = res.data.blocks.name
								res.data.blocks.json.wiki = res.data.blocks.wiki

								if (res.data.blocks.json.items) {
									if (res.data.blocks.json.items[0].length) {
										this.checkSaved(res.data.blocks.json.items[0])
									}
								}

								theArray[index] = res.data.blocks.json

								this.force_refresh = this.uuid()
								return true
							})
							.catch(err => console.error(err))
					}
				})
			}
		},

		async getData() {
			await axios(`${process.env.VUE_APP_API_URL}/api/documents/${this.selected_doc_id}`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(({ data }) => {
					this.document = data

					let { flowchart, publishedFlowchart } = this.document
					flowchart = flowchart || {}

					if (
						(Object.keys(flowchart).length && flowchart.status !== "published" && !publishedFlowchart) ||
						(!Object.keys(flowchart).length && !publishedFlowchart)
					)
						this.$router.go(-1)
				})
				.catch(error => console.error(error))

			const {
				flowchart: { id: flowchartId, unique_flowchart_id: uniqueFlowchartId }
			} = this.document

			await axios(`${process.env.VUE_APP_API_URL}/api/flowchart/getSaved/${flowchartId}`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(async res => {
					this.docTitle = res.data.items.nome
					for (let i = 0; i < res.data.items.dati.length; i++) {
						var tmpNodo = res.data.items.dati[i]

						if (tmpNodo.id === null) {
							tmpNodo.id = i
						}
						if (tmpNodo.value) {
							var tttmp = { id: 0, items: [], name: "" }
							tmpNodo.value.forEach(el78 => {
								var tmppppp = JSON.parse(el78.items)
								if (el78.block_type === "shared_blocks") {
									tmppppp.ref_id = el78.block_id
								}
								tmppppp.name = el78.name
								tmppppp.wiki = el78.wiki

								//qui mi arrabbio
								if (tmppppp.items) {
									this.checkSaved(tmppppp.items[0])
								}

								tttmp.items.push(tmppppp)
							})

							tmpNodo.value = [tttmp]
						} else {
							tmpNodo.value = [{ id: 0, items: [], name: "" }]
						}
						delete res.data.items.dati[i]["Items"]
					}
					this.doc = res.data.items.dati

					// this.question_tree = this.writeQuestionTree(0)
					this.getAllVar()

					await this.normalizeVars()

					await this.addQuestions(this.local_questions)
					await this.connectQuestionVar()
					await this.fillQuestions()
					this.loadNext = true

					return true
				})
				.catch(err => console.error(err))

			if (this.document.status === "confirmed" || this.exportHTML) return

			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/flowchart/getPublished`,
					{ uniqueFlowchartId },
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(({ data: publishedFlowchart }) => {
					if (publishedFlowchart.version === this.document.flowchart.version) return
					if (!this.mySubscription) return

					this.$confirm(this.$t("use-published-flowchart-version"))
						.then(() => {
							axios
								.put(
									`${process.env.VUE_APP_API_URL}/api/documents/update/${this.selected_doc_id}`,
									{ version: publishedFlowchart.version },
									{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
								)
								.then(() => {
									this.$notification("success", this.$t("save-successful"), "", 4500)
									// window.location.reload()
									// this.goto(this.$route)
									this.isLoaded = false
									this.variables = []
									this.clear()
									this.start()
								})
								.catch(() => this.$notification("error", this.$t("save-error"), "", 0))
						})
						.catch(() => {})
				})
				.catch(() => {})
		},

		async fillQuestions() {
			for (const quest of this.questions) {
				await axios
					.post(
						`${process.env.VUE_APP_API_URL}/api/customfieldvalues/getQuestion`,
						{ node_id: quest.node_id, document_id: this.document.id },
						{
							headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
						}
					)
					.then(async res => {
						if (res.data && quest.node_id == res.data.answer.node_id) {
							quest.value = Number(res.data.answer.answer)
							quest.saving_id = res.data.answer.id
						}
						return true
					})
					.catch(err => console.error(err))
			}
			return true
		},
		//al momento non viene usata ma potrebbe tornare utile, fa l'albero delle domande
		// da chiamare con this.question_tree = this.writeQuestionTree(0)
		writeQuestionTree(idx) {
			let m = {}
			let node = this.doc.find(x => x.id == idx)
			m[idx] = {}

			if (node) {
				if (node.question.value == "") {
					if (node.children.length) {
						m[idx] = this.writeQuestionTree(node.children[0])
					}
				} else {
					if (node.children.length)
						node.children.forEach(n => {
							m[idx][n] = { ...this.writeQuestionTree(n)[n] }
						})
				}
			}
			return m
		},
		/**
		 * magia, scorre i nodi e caccia fuori le variabili come elementi html da normalizzare (vedi normalizeVars)
		 * */
		getAllVar(itms = this.doc) {
			itms.forEach(n => {
				if (n.question) {
					if (n.question.value) {
						// aggiunge variabili non presenti nel documento ma come domanda
						if (typeof n.question.value === "object") {
							n.question.value.id = n.question.value.index
							this.variables.push(n.question.value)
						}

						this.local_questions.push({
							id: n.id,
							node_id: n.node_id,
							value: "",
							question: n.question
						})
					}
				}
				if (Array.isArray(n.value)) {
					n.value.forEach(n1 => {
						this.getAllVar(n1.items)
					})
				} else {
					if (n.items) {
						n.items.forEach(n1 => {
							this.getAllVar(n1)
						})
					} else {
						if (n.type === "editor") {
							if (n.value)
								if (n.value.docContent) {
									let doc = document.implementation.createHTMLDocument("")
									doc.open()
									doc.write(n.value.docContent)
									doc.close()

									this.variables.push(
										...Array.prototype.slice.call(doc.getElementsByClassName("custom-variable"))
									)
								}
						}
					}
				}
			})
		},
		async normalizeVars() {
			let tmpArr = []
			if (this.variables)
				this.variables.forEach(variable => {
					if (tmpArr.findIndex(x => x.id == variable.id.replace("x_", "")) === -1) {
						tmpArr.push({ id: variable.id.replace("x_", ""), rid: variable.id.replace("x_", "") })
					}
				})
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/customfields/getVariablesInfo",
					{
						document_id: this.selected_doc_id,
						spans: tmpArr,
						...(this.isSuperAdmin && { organization_id: this.$route.params.school_id })
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(({ data: { span: spans = [] } }) =>
					this.addVariables(
						(spans || []).map(span => {
							if (span.node.rules) span.node.rules = JSON.parse(span.node.rules)
							if (span.node_value == undefined) span.node_value = { custom_field_id: span.rid, value: "" }
							return span
						})
					)
				)
				.catch(err => {
					console.error(err)
				})
		},
		setField: _.debounce(function (node, valore) {
			if (!node.node_value) {
				node.node_value = {
					custom_field_id: node.node.id,
					value: valore
				}
			} else {
				node.node_value.value = valore
			}
			this.addVariables(this.normalizedVariables)
			this.connectQuestionVar()

			// this.$nextTick(() => this.calculateProgress())
		}, 200),
		calculateProgress() {
			return true
			//todo eliminare
			this.setPercentage(0)
			const fnIsCompiled = value => !!value
			let filled =
				this.variabili.filter(({ value }) => fnIsCompiled(value)).length +
				this.questions.filter(({ value }) => fnIsCompiled(value)).length
			this.setPercentage(Math.round((filled / (this.variabili.length + this.questions.length)) * 100))
		},
		focusField(field) {
			const target = Array.from(document.querySelectorAll(`[id^='x_${field.node.id}']`))
			// target[0].scrollIntoView({ behavior: "smooth" }, true)
			target.forEach(span => (span.style.backgroundColor = "yellow"))
		},
		unfocusField(field) {
			const target = Array.from(document.querySelectorAll(`[id^='x_${field.node.id}']`))
			target.forEach(span => (span.style.backgroundColor = "transparent"))
		},
		async handleImage(customFieldId, imageFile, variable) {
			let variabile = this.normalizedVariables.find(({ node: { id } }) => id == customFieldId)
			if (variabile) variabile.node.custom_field_value.value = imageFile
			// if (variabile) variabile.node_value.value = imageFile
			if (variabile.node.type == "image") variabile.node_value_file = await this.readFileAsDataURL(imageFile)
			this.setField(variable, variabile.node_value_file)
		},

		async readFileAsDataURL(file) {
			let result_base64 = await new Promise(resolve => {
				let fileReader = new FileReader()
				fileReader.onload = e => resolve(fileReader.result)
				fileReader.readAsDataURL(file)
			})

			return result_base64.split(",")[1]
		},

		isItAnObjectQuestionMark(val) {
			return typeof val !== "object"
		},
		handleSaveCommand(command) {
			this[command]()
		},
		handleExportCommand(command) {
			this[command]()
		},
		exportPdf() {
			const a = document.getElementById("rend" + this.random_id)
			const styles =
				"*{ -webkit-print-color-adjust: exact !important; color-adjust: exact !important;} table th, table td {border:1px solid #000} @page {size:auto; margin: 0;  }"

			const nodes = Array.from(document.getElementsByClassName("nodes"))
			nodes.forEach(n => {
				this.insertBlankRow(n, 1120)
			})
			const newWindow = window.open()
			newWindow.document.write(`<html><head><title>abc</title>`)
			newWindow.document.write("</head><body >")
			newWindow.document.write(a.innerHTML)
			newWindow.document.write("</body></html>")
			// newWindow.document.write(a.innerHTML)
			let css = newWindow.document.createElement("style")
			css.styleSheet
				? (css.styleSheet.cssText = styles)
				: css.appendChild(newWindow.document.createTextNode(styles))
			newWindow.document.body.appendChild(css)
			newWindow.print()
			newWindow.close()
		},

		exportActual() {
			let a = document.getElementById("rend" + this.random_id)

			if (a) {
				a = a.innerHTML

				if (this.document.status == "confirmed") a = this.document.html

				//conversione cose vuote
				const doc = new DOMParser().parseFromString(a, "text/html")
				const target = Array.from(doc.querySelectorAll(`[id^='x_']`))
				target.forEach(span => {
					span.style.border = "none"
					if (span.textContent[0] === "{" && span.textContent[span.textContent.length - 1] === "}") {
						span.innerHTML = "<span style='background-color: yellow; color: black;'>__________</span>"
					}
				})

				//evidenziati

				const marks = Array.from(doc.querySelectorAll(`mark`))
				marks.forEach(span => {
					span.innerHTML =
						"<span style='background-color: yellow; color: black;'>" + span.innerText + "</span>"
				})

				return doc.all[0].innerHTML
			} else {
				return "download error"
			}
		},
		/**
		 * NB. quando modifico exportDocx, modificare anche:
		 * exportActual (in questo file) + pushBoi (MyProjects)
		 **/
		exportDocx() {
			this.exporting = true
			const a = document.getElementById("rend" + this.random_id).innerHTML
			//conversione cose vuote
			const doc = new DOMParser().parseFromString(a, "text/html")
			const target = Array.from(doc.querySelectorAll(`[id^='x_']`))
			target.forEach(span => {
				span.style.border = "none"
				if (span.textContent[0] === "{" && span.textContent[span.textContent.length - 1] === "}") {
					span.innerHTML = "<span style='background-color: yellow; color: black;'>__________</span>"
				}
			})

			//evidenziati

			const marks = Array.from(doc.querySelectorAll(`mark`))
			marks.forEach(span => {
				span.innerHTML = "<span style='background-color: yellow; color: black;'>" + span.innerText + "</span>"
			})

			var b =
				'<p style="margin-left: 1cm; margin-right: 1cm; background: transparent">' +
				doc.body.innerHTML +
				// +"\t<style>\n" +
				// "\t\tp {\n" +
				// "\t\t\tmargin-block-start: 1 !important;\n" +
				// "\t\t\tmargin-block-end: 1 !important;\n" +
				// "\t\t}\n" +
				// "\n" +
				// "\t</style>"
				"</p>"

			b = b.replaceAll("<div", "<span")
			b = b.replaceAll('start="1"', "")
			b = b.replaceAll("keyboard_double_arrow_left", "")
			b = b.replaceAll("keyboard_double_arrow_right", "")

			// b= b.replaceAll("\n","")
			// b= b.replaceAll("\r","")
			// b= b.replaceAll("\r\n","")
			// b= b.replaceAll("\n","")

			//conversione cose vuote

			let blob = new Blob([b], { type: "text/html" })
			let form_data = new FormData()
			form_data.append("blob", blob)
			form_data.append("file_name", this.document.unique_flowchart_id)
			axios
				.post(process.env.VUE_APP_API_URL + "/api/docx/convert", form_data, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					axios
						.get(
							process.env.VUE_APP_API_URL +
								"/api/docx/export/" +
								res.data.name +
								"/" +
								this.document.flowchart.id,
							{
								headers: {
									Authorization: `Bearer ${localStorage.getItem("JWT")}`
								},
								responseType: "arraybuffer"
							}
						)
						.then(res => {
							const url = window.URL.createObjectURL(new Blob([res.data]))
							const link = document.createElement("a")
							link.href = url
							link.setAttribute("download", `${this.docTitle}.zip`)
							link.click()
							this.exporting = false
						})
						.catch(err => {
							console.error(err)
							this.exporting = false
						})
				})
				.catch(err => {
					console.error(err)
					this.exporting = false
				})
		},
		insertBlankRow(element, max_allowd_height) {
			element.childNodes.forEach((n, index) => {
				if (n.offsetHeight > max_allowd_height) {
					this.insertBlankRow(n, max_allowd_height)
				} else {
					const VNode1 = document.createElement(
						"div",
						{ style: `height: ${max_allowd_height - n.offsetHeight} ` },
						[]
					)
					Array.from(element.childNodes).splice(index, 0, VNode1)
				}
			})
		},
		getOwnerId(level) {
			if ([-1, 0].includes(level)) return this.user.organization.id
			if ([1].includes(level)) return this.document.project.project_id || this.document.project_id
			if ([2].includes(level)) return this.document.project_id
			if ([3].includes(level)) return this.document.id
			return 0
		},
		saveCustomFieldValues() {
			const getOwnerType = level => {
				if ([-1, 0].includes(level)) return "organizations"
				if ([1, 2].includes(level)) return "projects"
				if ([3].includes(level)) return "documents"
				return ""
			}

			const getValue = nodeId => {
				const variableInput =
					this.$refs["variable-input"][this.variabili.findIndex(({ node }) => node.id === nodeId)] || {}

				return String(variableInput.value || "")
			}

			const variables = this.variabili
				.filter(({ node: { type } }) => type !== "image")
				.map(({ node, node_value }) => ({
					id: node_value ? node_value.id || "0" : "0",
					value: getValue(node.id),
					custom_field_id: node.id,
					owner_type: getOwnerType(node.level),
					owner_id: this.getOwnerId(node.level)
				}))

			const questions = this.questions.map(el => ({
				id: String(el.saving_id ? el.saving_id || "0" : "0"),
				answer: String(el.value),
				node_id: String(el.node_id),
				document_id: String(this.document.id)
			}))

			const images = this.variabili
				.filter(({ node: { type } }) => type === "image")
				.map(({ node, node_value }) => {
					let formDataImage = new FormData()
					formDataImage.append("id", node_value ? node_value.id : "0")
					formDataImage.append("value", node.custom_field_value.value)
					formDataImage.append("custom_field_id", node.id)
					formDataImage.append("owner_type", getOwnerType(node.level))
					formDataImage.append("owner_id", this.getOwnerId(node.level))
					if (this.isSuperAdmin) formDataImage.append("organization_id", this.$route.params.school_id)
					return formDataImage
				})

			let apiCalls = []

			apiCalls.push(
				axios
					.post(
						`${process.env.VUE_APP_API_URL}/api/customfieldvalues/addOrUpdate`,
						{ variables, questions },
						{
							headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
						}
					)
					.then(({ data: { questions: questionVal, items: varValue } }) => {
						if (this.questions && questionVal)
							this.questions.forEach(el => {
								questionVal.forEach(el2 => {
									if (el2.id && el.node_id == el2.node_id) el.saving_id = el2.id
								})
							})

						if (this.normalizedVariables && varValue)
							this.normalizedVariables.forEach(el => {
								varValue.forEach(el2 => {
									if (el2.id && el.rid == el2.custom_field_id) {
										if (!el.node_value) el.node_value = {}
										el.node_value.id = el2.id
									}
								})
							})
					})
			)

			images.forEach(form =>
				apiCalls.push(
					axios.post(`${process.env.VUE_APP_API_URL}/api/customfieldvalues/addOrUpdateImage`, form, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					})
				)
			)

			axios
				.all(apiCalls)
				.then(() => {
					this.normalizeVars()
					this.$notification("success", this.$t("save-successful"), "", 4500)
				})
				.catch(err => {
					console.error(err)
					this.$notification("error", this.$t("save-error"), err, 0)
				})
		},
		async savePermanently() {
			let normalizedVariables = []
			this.normalizedVariables.forEach(field => {
				const target = document.getElementById(`x_${field.rid}`)
				const el = document.getElementById("com_" + field.rid + "-" + field.rid)
				if (target == undefined && el) {
					if (el.getAttribute("locked_qst") == "true") normalizedVariables.push(field)
				} else if (el) {
					normalizedVariables.push(field)
				}
			})

			let questions = []
			this.questions.forEach(node => {
				const el = document.getElementById("qst_" + node.id + "-" + node.id)

				if (el && el.getAttribute("hidden") != "true") {
					questions.push(node)
				}
			})

			let notCompiledText = normalizedVariables
				.filter(({ node_value }) => !node_value || !node_value.value)
				.filter(({ node }) => !node || !node.rules || !node.rules.nullable)
				.map(({ node: { name } }) => name)
			// .join(", ")

			let notCompiledAnswers = questions
				.filter(({ value }) => value == "")
				.map(({ question: { value } }) => value)
			// .join(", ")

			notCompiledText = notCompiledText.concat(notCompiledAnswers)
			notCompiledText = notCompiledText.join(", ")

			if (
				notCompiledText &&
				!(await this.$confirm(`${this.$t("warning-not-compiled")}: ${notCompiledText}`)
					.then(() => true)
					.catch(() => false))
			)
				return

			if (
				!(await this.$confirm(this.$t("confirm-save-document-permanently"))
					.then(() => true)
					.catch(() => false))
			)
				return

			const { innerHTML: html } = document.getElementById("save-permanently-html-preview")

			axios
				.put(
					`${process.env.VUE_APP_API_URL}/api/documents/update/${this.selected_doc_id}`,
					{ html, status: "confirmed" },
					{
						headers: {
							Authorization: `Bearer ${localStorage.getItem("JWT")}`
						}
					}
				)
				.then(() => {
					this.document.status = "confirmed"
					this.document.html = html
					this.$notification("success", this.$t("save-successful"), "", 4500)
				})
				.catch(() => this.$notification("error", this.$t("save-error"), "", 0))
		},
		hideVariables() {
			setTimeout(async () => {
				this.normalizedVariables.forEach(field => {
					const target = document.getElementById(`x_${field.rid}`)
					const el = document.getElementById("com_" + field.rid + "-" + field.rid)
					if (target == undefined && el) {
						el.setAttribute("locked_var", "false")
						if (el.getAttribute("locked_qst") == "false") el.setAttribute("hidden", true)
						else el.removeAttribute("hidden")
					} else if (el) {
						el.removeAttribute("hidden")
						el.setAttribute("locked_var", "true")
					}
				})
			}, 100)
		},
		writeQuestionPath(idx) {
			if (idx != undefined) {
				let index = this.question_path.findIndex(x => x == idx)
				if (index != -1) {
					this.question_path.length = index + 1
					this.question_path_variables.length = index + 1
				} else {
					this.question_path.push(idx)
					this.question_path_variables.push(-1)
				}
			}

			this.questions.forEach(node => {
				const el = document.getElementById("qst_" + node.id + "-" + node.id)

				let exists = this.question_path.findIndex(x => x == node.id)

				//nascondo o mostro la domanda se esiste nel question_path
				if (el) {
					if (exists != -1) el.removeAttribute("hidden")
					else el.setAttribute("hidden", true)
				}

				//nascondo o mostro le variabili associate alla domanda se esiste nel question_path
				if (node.question.value && node.question.value.id) {
					if (exists != -1) this.question_path_variables[exists] = node.question.value.id

					const var_el = document.getElementById(
						"com_" + node.question.value.id + "-" + node.question.value.id
					)

					if (var_el) {
						if (exists != -1 || this.question_path_variables.includes(node.question.value.id))
							var_el.setAttribute("locked_qst", "true")
						else var_el.setAttribute("locked_qst", "false")

						if (
							var_el.getAttribute("locked_var") == "true" ||
							var_el.getAttribute("locked_qst") == "true"
						) {
							var_el.removeAttribute("hidden")
						} else {
							var_el.setAttribute("hidden", true)
						}
					}
				}
			})
		},
		hideQuestions(node) {
			if (node) {
				if (node.question && node.question.value !== "") {
					setTimeout(async () => {
						this.writeQuestionPath(node.id)
					}, 300)
				}
			} else {
				this.writeQuestionPath(undefined)
			}
		},
		hideQuestions2(index) {
			this.writeQuestionPath(
				this.questions.filter(x => this.isItAnObjectQuestionMark(x.question.value))[index].id
			)
		}
	}
}
</script>

<style scoped>
.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	right: 0;
	bottom: 0;
	width: 0px;
	background-color: #f3f3f3 !important;
	transition: width 0.5s;
	border-radius: 25px 0 0 25px;
	height: 72.3vh;
	top: 18%;
}
</style>
